import * as React from "react";
import { Panel, Table, InputGroup, FormControl, Button } from "react-bootstrap";
import { ILogisticsOptionNote, IUser } from "@nkr/models/index";
import styled from "styled-components";
import OptionNotesRow from "./option-notes-row";

const TableWrapper = styled(Table)`
    & > thead > tr > th,
    & > tbody > tr > td {
        font-size: 12px;
    }
`;

interface IProps {
    notes: ILogisticsOptionNote[],
    user: IUser,
    readonly: boolean,
    onAdd: (value: string) => void,
    onUpdate: (index: number, value: string) => void,
    onDelete: (index: number) => void
}

interface IState {
    action: number,
    value: string,
    index: number
}

class OptionNotes extends React.Component<IProps, IState> {
    readonly state: IState = {
        action: 0,
        value: '',
        index: 0
    }

    handleAdd = () => {
        let { value } = this.state;

        this.setState({
            action: 0,
            value: '',
            index: 0
        }, () => {
            this.props.onAdd(value);
        });
    }

    handleEdit = (index: number) => {
        let note = this.props.notes[index];

        this.setState({
            action: 1,
            value: note.notes,
            index
        });
    }

    handleCancelEdit = () => {
        this.setState({
            action: 0,
            value: '',
            index: 0
        });
    }

    handleUpdate = () => {
        let { index, value } = this.state;

        this.setState({
            action: 0,
            value: '',
            index: 0
        }, () => {
            this.props.onUpdate(index, value);
        });
    }

    handleDelete = (index: number) => {
        this.props.onDelete(index);
    }

    handleNoteChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        this.setState({
            value: e.currentTarget.value
        });
    }

    render = () => {
        return (
            <Panel>
                <Panel.Heading style={{ padding: "5px 7.5px" }}>Notes</Panel.Heading>
                <Panel.Body>
                    <TableWrapper condensed>
                        <thead>
                            <tr>
                                <th style={{ width: '20%' }}>Log Date/Time</th>
                                <th>Notes</th>
                                <th style={{ width: '18%' }}>Created By</th>
                                <th style={{ width: '13%' }}></th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.props.notes.map((item, index) =>
                                <OptionNotesRow
                                    key={index}
                                    index={index}
                                    note={item}
                                    userId={this.props.user.id}
                                    readonly={this.props.readonly}
                                    onEdit={this.handleEdit}
                                    onDelete={this.handleDelete}
                                />
                            )}

                            {this.props.notes.length == 0 && (
                                <tr>
                                    <td colSpan={3}>
                                        [No previously entered notes...]
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </TableWrapper>

                    <InputGroup bsSize="small" style={{ marginTop: 10 }}>
                        <FormControl
                            readOnly={this.props.readonly}
                            value={this.state.value}
                            onChange={this.handleNoteChange}
                        />
                        <InputGroup.Button>
                            {this.state.action == 0 && (
                                <Button bsStyle="primary" disabled={this.props.readonly} onClick={this.handleAdd}>Add Note</Button>
                            )}

                            {this.state.action == 1 && (
                                <>
                                    <Button bsStyle="primary" disabled={this.props.readonly} onClick={this.handleUpdate}>Update Note</Button>
                                    <Button disabled={this.props.readonly} onClick={this.handleCancelEdit}>Cancel</Button>
                                </>
                            )}
                        </InputGroup.Button>
                    </InputGroup>
                </Panel.Body>
            </Panel>
        );
    }
}

export default OptionNotes;